import { getRequest } from "../../../../api/client";
import { STREET_API } from "../../../../Endpoints";
import { StreetModel } from "../models/StreetModel";

export const getStreets = async () => {
  return getRequest<StreetModel[]>(STREET_API);
};
